import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import { Price } from 'swag-client-common/utils/price';
import Button from '../../../../ui/button/index';
import classes from '../../kickstarter-shipping-popup.scss';
function KickstarterShippingProposals({
  onAddToOrder,
  // onClose,
  ksFulfillment,
  validCount,
  // invalidCount,
  uploadState
}) {
  const isLoading = uploadState === 'loading';
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", {
    className: classes.popupHeader
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.KSLabel
  }, "KICKSTARTER")), /*#__PURE__*/React.createElement("p", {
    className: classes.popupContent
  }, "You have successfully uploaded ", validCount, " addresses."), /*#__PURE__*/React.createElement("p", {
    className: classes.popupContent
  }, "Your Kickstarter fulfillment will cost", ' ', /*#__PURE__*/React.createElement("span", {
    className: classes.greenText
  }, Price.formatPrice(ksFulfillment)), ", this will be added", /*#__PURE__*/React.createElement("br", null), "to your total on the order summary."), /*#__PURE__*/React.createElement("div", {
    className: classes.popupActions
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.proposals_applyBtn,
    onClick: isLoading ? () => undefined : onAddToOrder
  }, isLoading ?
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(CircularProgress, {
    className: classes.loader,
    color: '#fff',
    size: 60
  }) : null, /*#__PURE__*/React.createElement("span", null, isLoading ? '\u00A0' : 'Add to order'))));
}
export default KickstarterShippingProposals;